import * as React from "react";
import { useHistory } from "react-router";
import { Form, Popup, Icon } from "semantic-ui-react";
import { useIntl, FormattedMessage } from "react-intl";

import { BasicFormProps } from "@/interfaces";
import { FloatedCard } from "@/containers/FloatedCard";
import { URLS } from "@/utils";
import "./styles.scss";

import { descriptors, RecoverPasswordType } from "./descriptors";

interface OwnProps extends BasicFormProps {
  passwordInputId?: string;
  confirmPasswordInputId?: string;
  isSuccess?: boolean;
  subtitle?: string;
}

type Props = OwnProps;

/**
 * Represents a ChangePassword content.
 */
const ChangePasswordFC: React.FC<Props> = ({
  passwordInputId = "password",
  confirmPasswordInputId = "confirmPassword",
  messages,
  subtitle,
  isSuccess,
  handleChange,
  handleSubmit,
  isSubmitting,
}) => {
  const history = useHistory();
  const { formatMessage } = useIntl();

  const toLogin = (): void => {
    history.push(URLS.login);
  };

  const successContent = <Icon name="check circle" size="huge" color="green" className={"cpwSuccessIcon"} />;

  const content = (
    <React.Fragment>
      <Form.Input
        id={passwordInputId}
        name="password"
        data-elm-id={"changePasswordInputPassword"}
        fluid
        icon={
          <Popup trigger={<Icon name="info circle" className={"infoIcon"} link />}>
            <FormattedMessage {...descriptors[RecoverPasswordType.passwordWithNumber]} />
            <br />
            <FormattedMessage {...descriptors[RecoverPasswordType.passwordWithCapital]} />
            <br />
            <FormattedMessage {...descriptors[RecoverPasswordType.passwordWithSpecialCharacter]} />
            <br />
            <FormattedMessage {...descriptors[RecoverPasswordType.passwordMin]} />
          </Popup>
        }
        type="password"
        placeholder={formatMessage({ ...descriptors[RecoverPasswordType.password] })}
        onChange={handleChange}
        disabled={isSubmitting}
      />
      <Form.Input
        id={confirmPasswordInputId}
        name="confirmPassword"
        data-elm-id={"changePasswordInputConfirm"}
        type="password"
        fluid
        placeholder={formatMessage({ ...descriptors[RecoverPasswordType.confirmPassword] })}
        onChange={handleChange}
        disabled={isSubmitting}
      />

      <Form.Button fluid size="large" type="submit" disabled={isSubmitting} onClick={handleSubmit}>
        <FormattedMessage {...descriptors[RecoverPasswordType["submit"]]} />
      </Form.Button>

      <div className="buttons-link">
        <span onClick={toLogin}>
          <FormattedMessage {...descriptors[RecoverPasswordType.logIn]} />
        </span>
      </div>
    </React.Fragment>
  );

  return (
    <FloatedCard
      title={formatMessage({ ...descriptors[RecoverPasswordType.title] })}
      subtitle={subtitle}
      content={isSuccess ? successContent : content}
      messages={messages}
      isSubmitting={isSubmitting}
      size={"small"}
      containerPadding={"small"}
    />
  );
};

export const ChangePassword = ChangePasswordFC;
